module.exports = __webpack_public_path__ + "img/1.eb759c0d.png";